import React, { useRef, useState } from 'react'
import { useEffect } from 'react';
import axios from 'axios';
import { environment } from '../../env';
import { useParams, Link, useNavigate } from 'react-router-dom';
import "../BuildingViewCard/BuildingDropDown.css"
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import EmptyTable from '../errorComponents/EmptyTable';
import BuildingExcelTable from '../Tables/BuildingExcelTable';
import moment from 'moment';
import PathName from '../PathName/PathName';
import jsPDF from 'jspdf';

function ProjectViewCard() {
    const [projectdata, setProjectData] = useState()
    const [buildingdata, setBuildingData] = useState();
    const [counter, setCounter] = useState(0);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const navigate = useNavigate();
    const projectDetails = useRef(null)
    const { id } = useParams()

    const viewBuildingData = () => {
        axios.get(`${environment.baseUrl}editproject/${id}`).then(res => {
            setProjectData(res.data)

        })
            .catch(res => {
                console.log("errorss", res.message);
            })

    }
    const BuildingData = () => {
        axios.get(`${environment.baseUrl}getbuilding/${id}`).then(res => {
            const tableArr = []
            res.data?.map((curElem, i) => {
                const remSpace = (curElem.area_builtup) - (curElem.sold_area)
                tableArr.push({
                    id: curElem.id,
                    building_no: curElem.building_no,
                    area_builtup: curElem.area_builtup,
                    area_carpet: curElem.area_carpet,
                    sold_area: curElem.sold_area,
                    remaining_space: remSpace,
                    gala_created: curElem.gala_created
                })
            })
            setBuildingData(tableArr)

        })
            .catch(res => {
                console.log("errorss");
            })
    }

    const pdfDownload = () => {
        const content = projectDetails.current;
        var doc = new jsPDF('l',)
        doc.html(content, {
            callback: (doc) => {
                window.open(doc.output('bloburl'));
            },
            html2canvas: { scale: 0.204 },
            margin: [11, 2, 2, 2],
        })
    }

    const columns = [
        {
            name: 'Building Name',
            selector: row => row.building_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'BuiltUp Area',
            selector: row => (row.area_builtup) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Carpet Area',
            selector: row => (row.area_carpet) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Sold Space',
            selector: row => (row.sold_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Remaining Space',
            selector: row => (row.remaining_space) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: "Gala's Created",
            selector: row => row.gala_created,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
    ]

    useEffect(() => {
        viewBuildingData();
        BuildingData();
    }, [])

    return (
        <div className="">
            <PathName />
            <div className="d-flex justify-content-between align-items-center py-5 px-3 pt-2">
                <button className="d-flex align-items-center border-0 bg-transparent" onClick={() => navigate(-1)}>
                    <i className='bx bx-arrow-back fs-2 title-font-600 px-2 bx-fade-left'></i>
                    <span className='fs-3 base-font-600'>Back</span> </button>
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle className="border-0 bg-transparent">
                        <button className="buttons px-3 py-3 rounded-3"  >
                            <i className='bx-tada bx bx-download fs-1 base-text-color ' ></i>
                        </button>
                    </DropdownToggle>
                    <DropdownMenu className='shadow-lg bg-body rounded-4 border-0 dropdown-menus p-3 '>
                        <DropdownItem onClick={pdfDownload} className='border-0 outline-none px-2 py-2 d-flex align-items-center'>
                            <i className="fa-regular fa-file-pdf fs-1 base-text-color px-2"></i>
                            <Link className='text-dark text-decoration-none title-font-500 fs-3 dropdown-item px-4' to=''>PDF</Link>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
            <div ref={projectDetails} className="bg-white d-flex mb-5  flex-column border-radius-32">
                <div className='d-flex flex-column justify-content-center align-items-strat align-items-md-center  align-items-lg-center align-items-xl-center align-items-sm-center bg-base-color p-5 border-radius-32-top'>
                    <h1 className='title-font-600 text-base-white fs-1 text-capitalize'>{projectdata?.name}</h1>
                    <p className='base-font-600 fs-3 text-base-white w-75 text-center '>{projectdata?.address1},{projectdata?.address2},
                        Near by {projectdata?.near_by} , {projectdata?.village_name?.name} ,  {projectdata?.city?.city_name} , {projectdata?.state} {projectdata?.country} Pin-{projectdata?.pincode}</p>
                </div>
                <div className="card w-100 border-0 rounded-5">
                    <div className="row g-0 border-bottom p-5">
                        <div className="col-md-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Project Name : <span className='fs-3 base-font-400'>{projectdata?.name}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Building : <span className='fs-3 base-font-400'>{buildingdata?.length}</span> </h5>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Total Area of Project : <span className='fs-3 base-font-400'>{projectdata?.total_area_of_project}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Ready Area in Project : <span className='fs-3 base-font-400'>{projectdata?.occupied_area}</span> </h5>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Created On : <span className='fs-3 base-font-400'>{moment(projectdata?.created_at).format('DD/MM/YYYY')}</span> </h5>
                            </div>
                        </div>
                    </div>
                    <div className="row g-0  p-5">
                        <div className="col-md-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Address Line 1 :  <span className='fs-3 base-font-400'>{projectdata?.address1}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Village :  <span className='fs-3 base-font-400'>{projectdata?.village_name?.name}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Pin Code       :  <span className='fs-3 base-font-400'>{projectdata?.pincode}</span> </h5>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Address Line 2 :  <span className='fs-3 base-font-400'>{projectdata?.address2}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">City           :  <span className='fs-3 base-font-400'>{projectdata?.city?.city_name}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Country :  <span className='fs-3 base-font-400'>{projectdata?.country}</span> </h5>

                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Near By :  <span className='fs-3 base-font-400'>{projectdata?.near_by}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">State :  <span className='fs-3 base-font-400'>{projectdata?.state}</span> </h5>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <div onClick={() => { setCounter(counter + 1) }} className="bg-white p-5 d-flex  flex-column rounded-5 mb-5">
                {/* <Properties buildingdata={buildingdata} counter={counter} /> */}
                {buildingdata == undefined || buildingdata?.length <= 0 ? <EmptyTable /> : < BuildingExcelTable columns={columns} title={`Buildings in ${projectdata?.name}`} data={buildingdata} />}
            </div>
        </div>

    )
}

export default ProjectViewCard


